import React from 'react';
import styled from 'styled-components';
import HowToRead, { SectionShell, EditButton } from './HowToRead';

const Card = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.report.grayLight};
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 14px;
`;

const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  h4 { margin: 0; font-size: 16px; font-weight: 800; color: ${({ theme }) => theme.colors.report.brand}; }
  h4 b { color: ${({ theme }) => theme.colors.report.noteTitle}; margin-right: 8px; }
`;

const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.report.muted};
`;

const Chip = styled.span`
  padding: 3px 10px;
  border-radius: 999px;
  font-weight: 700;
  background: ${({ $p, theme }) => ($p === 'high' ? theme.colors.report.priorityBg : $p === 'medium' ? theme.colors.report.strongBg : theme.colors.report.panel)};
  color: ${({ $p, theme }) => ($p === 'high' ? theme.colors.report.noteTitle : $p === 'medium' ? theme.colors.report.blue : theme.colors.report.muted)};
`;

const Cols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.4fr 1fr;
  gap: 20px;
  font-size: 13px;
  line-height: 1.55;
  h5 { margin: 0 0 6px; font-size: 12px; font-weight: 800; color: ${({ theme }) => theme.colors.report.brand}; }
  ol { margin: 0; padding-left: 18px; }
`;

export default function Recommendations({ narrative, t, canEdit, onEdit }) {
  if (!narrative) return null;
  return (
    <SectionShell
      id="s06"
      title={t('survey.report.section.s06')}
      actions={canEdit ? <EditButton t={t} onClick={() => onEdit('recommendations')} testId="edit-recommendations" /> : null}
    >
      <HowToRead t={t}>{t('survey.report.help.recommendations')}</HowToRead>
      {narrative.recommendations.map((r, i) => (
        <Card key={i}>
          <CardHead>
            <h4><b>{String(i + 1).padStart(2, '0')}</b>{r.title}</h4>
            <Meta>
              <span>{r.codes.join(' · ')}</span>
              <Chip $p={r.priority}>{t(`survey.report.priority.${r.priority}`)}</Chip>
            </Meta>
          </CardHead>
          <Cols>
            <div><h5>{t('survey.report.finding')}</h5>{r.finding}</div>
            <div><h5>{t('survey.report.steps')}</h5><ol>{r.steps.map((s, j) => <li key={j}>{s}</li>)}</ol></div>
            <div><h5>{t('survey.report.expectedOutcome')}</h5>{r.expectedOutcome}</div>
          </Cols>
        </Card>
      ))}
    </SectionShell>
  );
}
